import { createBrowserClient } from "@supabase/ssr"
import { authCookieOptions, shouldPersistSession } from "@/lib/supabase/cookie-options"
import { inMemoryAuthLock } from "@/lib/supabase/auth-lock"

let supabaseClient: ReturnType<typeof createBrowserClient> | null = null

export function createClient() {
  if (supabaseClient) {
    return supabaseClient
  }

  supabaseClient = createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      // Persist the auth-token cookies across browser restarts (unless the
      // user explicitly opted out via "Remember me"). Without an explicit
      // maxAge these become session cookies and users get logged out every
      // time they close the browser / the installed PWA.
      cookieOptions: authCookieOptions(shouldPersistSession()),
      auth: {
        // Replace gotrue's default cross-tab navigator.locks lock, which can
        // hang every auth call forever if a stale lock is left held (PWA /
        // multiple tabs / backgrounded tab). See lib/supabase/auth-lock.ts.
        lock: inMemoryAuthLock,
      },
    },
  )

  return supabaseClient
}

export { createClient as createBrowserClient }
